// Pure rule for which electric connections show in the Rechnungsversand summary
// (and are thus transferable to the Beleg). Side-effect free → unit testable.

import { ElectricMeterProductKey } from '@shared/models/electric-meter-product-type';

import { BookingV2ElectricMeterAssignment } from '../dtos/booking-v2.dtos';

// A connection is shown when its amount is a known fixed sum (product × quantity):
//  - PREPAID  → billed upfront, shown as soon as it has a billing product.
//  - FLATRATE → only once disconnected (getrennt → end date set).
//  - BY_USAGE / NO_CHARGE → never (consumption is settled via the power tab).
// `productPrice` must be known to show a gross (absent on a thin edit-load graph).
export function isElectricBelegEligible(m: BookingV2ElectricMeterAssignment): boolean {
    if (m.productId == null || m.productPrice == null) {
        return false;
    }
    if (m.productTypeKey === ElectricMeterProductKey.PREPAID) {
        return true;
    }
    return m.productTypeKey === ElectricMeterProductKey.FLATRATE && m.to != null;
}
